/**
 * Carries the `settingsValues` object for a proto user-app-settings write.
 */
export class UpdateProtoUserAppSettingsDto {
  settingsValues!: Record<string, unknown>;
}
